import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
const PaymentsActions = importer('Stores/Payments/Actions')
const { applyPaymentPromoCode } = importer('APIs/payments', null)
const { tokens } = importer('Stores/Users/Select', null)

export default function * main ({ promoCode, overrideOthers }) {
  try {
    yield put(PaymentsActions.applyPaymentPromoCodeLoading())
    const _tokens = yield select(tokens)
    let res = null
    if (_tokens) {
      const { token_type, id_token } = _tokens
      const token = `${token_type} ${id_token}`
      res = yield applyPaymentPromoCode(promoCode, overrideOthers, token)
    } else {
      res = yield applyPaymentPromoCode(promoCode, overrideOthers)
    }
    if (!res.data.success){
      let errorResponse = {
        code:res.data.errors[0]?.code,
        message:res.data.errors[0]?.description}
      yield put(PaymentsActions.applyPaymentPromoCodeFailure(errorResponse))
    }else{
      yield put(PaymentsActions.applyPaymentPromoCodeSuccess(res))
    }
  } catch (error) {
    yield put(PaymentsActions.applyPaymentPromoCodeFailure(error.response.data))
  }
}
